import { FCX, RecentSearches as PlatformRecentSearches } from "@datassential/platform-ui-lib";
import { useMemo } from "react";
import { excludeNullable, mapByKey } from "@core/utils/array";
import cn from "classnames";
import { useRecentSearches } from "@api/useRecentSearches";
import useApplySearch from "@vms/ToolSearch/useApplySearch";

const RecentSearches: FCX = ({ className }) => {
    const { isLoading: isRecentSearchesLoading, data: rawRecentSearches } = useRecentSearches();
    const applySearch = useApplySearch();

    const recentSearches = useMemo(() => excludeNullable(mapByKey(rawRecentSearches, 'text')), [rawRecentSearches]);

    if (isRecentSearchesLoading || !recentSearches.length) return null;

    return (
        <PlatformRecentSearches
            className={cn(
                "ToolSearch__recent-searches",
                "ToolSearchRecentSearches",
                "appears-top",
                "fast",
                className
            )}
            title={"Recent Searches"}
            searches={recentSearches}
            onSearchClick={applySearch}
        />
    );
};

export default RecentSearches;